import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { ROL } from '../../lib/role.enum';

/**
 * @typedef {import ('../../interfaces/services/IUser.interface').ILoginAccesoAutorizado}
 */
const defaultValues = {
  role: ROL.ADMINISTRADOR,
  user: '',
  password: '',
};

const resolver = yupResolver(
  yup.object().shape({
    role: yup.string(),
    user: yup.string().when('role', {
      is: (role) => role !== ROL.AUTORIDAD,
      then: yup.string().notRequired(),
      otherwise: yup.string().required('Campo obligatorio'),
    }),
    password: yup.string().when('role', {
      is: (role) => role !== ROL.AUTORIDAD,
      then: yup.string().notRequired(),
      otherwise: yup.string().required('Campo obligatorio'),
    }),
  })
);

export { defaultValues, resolver };
